import React, { useState, useEffect} from 'react';
import styles from './PaymentForm.module.css';
import { useParams } from 'react-router-dom';
import { useTitle } from '../../hooks/useTitle';
import CryptoOption from "../../components/CryptoOption"

import classNames from 'classnames';
import NetworkOption from '../../components/NetworkOption';
const PaymentForm = (
    {
          autoLoadFromUrl = false
    }
) => {
    useTitle("Оплата заказа")
  const params = useParams()
  const [emailValid, setEmailValid] = useState('');
  const [email, setEmail] = useState('');
  const [showCvv, setShowCvv] = useState(false)
  const [config, setConfig] = useState(null);
  const [configLoading, setConfigLoading] = useState(false);
  const [configError, setConfigError] = useState(null);
  const [statusPolling, setStatusPolling] = useState(null);

  const [initialLoading, setInitialLoading] = useState(true); 
  const networks = {
    TON: [
      { id: 'TON', name: 'TON Network', desc: 'Основная сеть', fee: '~$5-20', color: '#0098EA', icon: 'T' },
    ],
    USDT: [
      { id: 'TON', name: 'TON Network', desc: 'Низкие комиссии', fee: '~$5-20', color: '#0098EA', icon: 'T' },
      { id: 'ETH', name: 'Ethereum (ERC-20)', desc: 'Дополнительная сеть', fee: '~$5-20', color: '#627eea', icon: 'E' },
      { id: 'TRON', name: 'Tron (TRC-20)', desc: 'Основная сеть', fee: '~$1', color: '#ff060a', icon: 'T' },
      { id: 'BSC', name: 'BSC (BEP-20)', desc: 'Binance Smart Chain', fee: '~$0.3', color: '#f3ba2f', icon: 'B' },

    ],
    USDC: [
      { id: 'ETH', name: 'Ethereum (ERC-20)', desc: 'Основная сеть', fee: '~$5-20', color: '#627eea', icon: 'E' },
      { id: 'BSC', name: 'BSC (BEP-20)', desc: 'Binance Smart Chain', fee: '~$0.01', color: '#f3ba2f', icon: 'B' },
    ]
  };
  

  const activeConfig = config || {
    amount: 0,
    orderId: "0",
    token: "_",
    timestamp: "0",
    showEmail: false,
    enableSbp: false,
    enableCard: false
  };

  const { amount, orderId, token, timestamp, showEmail, enableSbp, enableCard } = activeConfig;
  const [selectedMethod, setSelectedMethod] = useState(enableSbp ? 'sbp' : 'card');
  
  const checkPaymentStatus = async () => {
 

  try {

    const response = await fetch(`https://www.ipalinks.ru/status-payment/${orderId}/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });

    if (response.ok) {
      const statusData = await response.json();

      // Обработка различных статусов
      switch (statusData.status) {
        case 'Paid':
          // Платеж завершен успешно
          clearInterval(statusPolling);
          openModal('success', 'Платеж завершен!', 'Ваш платеж успешно обработан');
          // Опционально: перенаправление или закрытие формы
          window.location.href = statusData.url;
          break;
   
        case 'Expired':

          clearInterval(statusPolling);
          openModal('error', 'Время истекло', 'Время для оплаты истекло. Создайте новый платеж.');
          break;
          
        default:
          // pending - продолжаем ожидание
          break;
      }
    }
  } catch (error) {
    console.error('Error checking payment status:', error);
    // Не показываем ошибку пользователю при проблемах с проверкой статуса
    // так как это фоновая операция
  }
};
  const startStatusPolling = () => {

  if (statusPolling) {
    clearInterval(statusPolling);
  }


  checkPaymentStatus();


  const interval = setInterval(() => {
    checkPaymentStatus();
  }, 10000); 

  setStatusPolling(interval);
};
  const fetchPaymentConfig = async (transactionId) => {
    setConfigLoading(true);
    setConfigError(null);
    
    try {
      const response = await fetch(`https://ipalinks.ru/transaction/${transactionId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        window.location.href = "https://ipalinks.ru/404"
        // throw new Error(`Ошибка загрузки: ${response.status}`);
      }

      const configData = await response.json();
      if (configData.amount == 0) {
        window.location.href = configData.url
      }
      setConfig(configData);
      
      // Обновляем выбранный метод в зависимости от настроек
      if (!configData.enableSbp && configData.enableCard) {
        setSelectedMethod('card');
      } else if (configData.enableSbp && !configData.enableCard) {
        setSelectedMethod('sbp');
      }  else if (configData.enableSbp && configData.enableCard) {
        setSelectedMethod('sbp');
      } else {
        setSelectedMethod('crypto');
      }
      
      return configData;
    } catch (error) {
      console.error('Ошибка получения конфигурации платежа:', error);
      setConfigError(error.message);
      throw error;
    } finally {
      setConfigLoading(false);
      setInitialLoading(false);
    }
  };
  const [cardData, setCardData] = useState({
    number: '',
    expiry: '',
    cvv: ''
  });
  const [cryptoCurrency, setCryptoCurrency] = useState(null);
  const [cryptoNetwork, setCryptoNetwork] = useState(null);
  const availableNetworks = cryptoCurrency ? networks[cryptoCurrency] || [] : [];
  const [showCryptoPayment, setShowCryptoPayment] = useState(false);
  const [cryptoPaymentData, setCryptoPaymentData] = useState(null);
  const [timeLeft, setTimeLeft] = useState(7200); // 2 часа в секундах
  const [isLoading, setIsLoading] = useState(false);
  const [preloader, setPreloader] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const goBackToPayment = () => {
    setShowCryptoPayment(false);
    setCryptoPaymentData(null);
    setTimeLeft(7200);
  };
  const [modalData, setModalData] = useState({ type: 'error', title: '', message: '' });
  const [wataCheckoutLoaded, setWataCheckoutLoaded] = useState(false);
  useEffect(() => {

    let timer;
    if (showCryptoPayment && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft(prev => {
          if (prev <= 1) {
            // Когда время истекло, можно показать сообщение об истечении времени
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    
    return () => {
      if (timer) clearInterval(timer);
    };
  }, [showCryptoPayment, timeLeft]);
  const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text).then(() => {
    openModal('success', 'Скопировано!', 'Адрес скопирован в буфер обмена');
  }).catch(() => {
    // Fallback для старых браузеров
    const textArea = document.createElement('textarea');
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
    openModal('success', 'Скопировано!', 'Адрес скопирован в буфер обмена');
  });
};
const formatTime = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};
  useEffect(() => {

    if (autoLoadFromUrl && params.transactionId) {
        fetchPaymentConfig(params.transactionId);
        
        
        }
    else {
        setInitialLoading(false);
        window.setTimeout(()=> {
          setPreloader(false)

          }, 2000
        )
    }

    }, [autoLoadFromUrl, params.transactionId, setPreloader]);
    
  useEffect(() => {
        if (!enableSbp && enableCard) {
        setSelectedMethod('card');
        } else if (enableSbp && !enableCard) {
        setSelectedMethod('sbp');
        } else if (enableSbp) {
        setSelectedMethod('sbp');
        }
  }, [enableSbp, enableCard]);

  const loadConfigManually = async (transactionId) => {
    try {
      await fetchPaymentConfig(transactionId);
      
    } catch (error) {
    }
  };
  
  
  useEffect(() => {
  
    if (amount === 0) {
        loadConfigManually(params.pay_id)
    }
    const loadWataCheckout = () => {
     
      if (window.WataCheckout) {
        setWataCheckoutLoaded(true);
        return;
      }
      const existingScript = document.querySelector('script[src="https://static.wata.pro/checkout.js"]');
      if (existingScript) {
        existingScript.remove();
      }
      const script = document.createElement('script');
      script.src = 'https://static.wata.pro/checkout.js';

      script.onload = () => {
        setWataCheckoutLoaded(true);
      };
      script.onerror = () => {
        console.error('Failed to load script');
        setWataCheckoutLoaded(false);
      };
      document.head.appendChild(script);

    };
    loadWataCheckout()
  }) 
  
  const formatAmount = (amount) => {
    return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    
    if (value.length === 0) {
      setEmailValid(null);
    } else {
      setEmailValid(validateEmail(value));
    }
  };

  const handleCardNumberChange = (e) => {
    let value = e.target.value.replace(/\D/g, '');
    let formattedValue = value.replace(/(\d{4})(?=\d)/g, '$1 ');
    
    if (formattedValue.length > 19) {
      formattedValue = formattedValue.substring(0, 19);
    }
    
    setCardData(prev => ({ ...prev, number: formattedValue }));
  };

  const handleExpiryChange = (e) => {
    let value = e.target.value.replace(/\D/g, '');
    if (value.length >= 2) {
      let month = value.substring(0, 2);
      let year = value.substring(2, 4);
      
      if (parseInt(month) > 12 || parseInt(month) < 1) {
        month = '12';
      }
      
      value = month + (year ? '/' + year : '');
    }
    setCardData(prev => ({ ...prev, expiry: value }));
  };

  const handleCvvChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    setCardData(prev => ({ ...prev, cvv: value }));
  };

  const openModal = (type, title, message) => {
    setModalData({ type, title, message });
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  // Получение WataCheckout (реального или имитации)
  const getWataCheckout = () => {


    return window.WataCheckout();

  };

  const handle3DSecure = (threeDsData) => {
    const form = document.createElement('form');
    form.method = threeDsData.method;
    form.action = threeDsData.url;
    form.style.display = 'none';

    for (const [key, value] of Object.entries(threeDsData.parameters)) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = value;
      form.appendChild(input);
    }

    if (threeDsData.threeDSSessionData) {
      const threeDSSessionData = document.createElement('input');
      threeDSSessionData.type = 'hidden';
      threeDSSessionData.name = 'threeDSSessionData';
      threeDSSessionData.value = threeDsData.threeDSSessionData;
      form.appendChild(threeDSSessionData);
    }

    if (threeDsData.creq) {
      const creq = document.createElement('input');
      creq.type = 'hidden';
      creq.name = 'creq';
      creq.value = threeDsData.creq;
      form.appendChild(creq);
    }

    document.body.appendChild(form);
    form.submit();
  };

  const processPayment = async () => {


    // if (!wataCheckoutLoaded) {
    //   openModal('error', 'Ошибка инициализации', 'Система оплаты еще загружается. Попробуйте через несколько секунд.');
    //   return;
    // }

    if (showEmail && (!email || !validateEmail(email))) {
      openModal('error', 'Ошибка валидации', 'Введите корректный email адрес для получения чека');
      return;
    }
    

    if (selectedMethod === 'sbp') {
      setIsLoading(true);
      
      const requestBody = {
        amount: amount,
        deviceData: "",
        ...(showEmail && { email: email })
      };

      try {


        const response = await fetch(`https://www.ipalinks.ru/create-payments-sbp/${orderId}/${token}/${timestamp}/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestBody)
        });

        if (response.ok) {
          const result = await response.json();
          setIsLoading(false);
          
          if (result.url) {
            window.location.href = result.url;
          }
          
          openModal('success', 'Платеж создан!', 
            showEmail ? `После оплаты чек будет отправлен на: ${email}` : 'Счет на оплату сформирован');
        } else {
          setIsLoading(false);
          const errorData = await response.json().catch(() => ({}));
          console.error('Ошибка создания платежа:', response.status, errorData);
          openModal('error', 'Ошибка создания платежа', 
            errorData.message || `Ошибка сервера (${response.status})`);
        }
      } catch (error) {
        setIsLoading(false);
        console.error('Ошибка платежа:', error);
        
        if (error.name === 'TypeError' && error.message.includes('fetch')) {
          openModal('error', 'Ошибка сети', 'Проверьте подключение к интернету и попробуйте снова');
        } else {
          openModal('error', 'Ошибка создания платежа', `Ошибка оплаты: ${error.message}`);
        }
      }

    }else if (selectedMethod === 'sbp-reserve') {
      setIsLoading(true);
      
      const requestBody = {
        amount: amount,
        deviceData: "",
        email: email 
      };

      try {


        const response = await fetch(`https://www.ipalinks.ru/create-payments-sbp-reserve/${orderId}/${token}/${timestamp}/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestBody)
        });

        if (response.ok) {
          const result = await response.json();
          setIsLoading(false);
          
          if (result.url) {
            window.location.href = result.url;
          }
          
          openModal('success', 'Платеж создан!', 
            showEmail ? `После оплаты чек будет отправлен на: ${email}` : 'Счет на оплату сформирован');
        } else {
          setIsLoading(false);
          const errorData = await response.json().catch(() => ({}));
          console.error('Ошибка создания платежа:', response.status, errorData);
          openModal('error', 'Ошибка создания платежа', 
            errorData.message || `Ошибка сервера (${response.status})`);
        }
      } catch (error) {
        setIsLoading(false);
        console.error('Ошибка платежа:', error);
        
        if (error.name === 'TypeError' && error.message.includes('fetch')) {
          openModal('error', 'Ошибка сети', 'Проверьте подключение к интернету и попробуйте снова');
        } else {
          openModal('error', 'Ошибка создания платежа', `Ошибка оплаты: ${error.message}`);
        }
      }

    } else if (selectedMethod === 'crypto') {
      setIsLoading(true);
      if (!cryptoCurrency) {
            openModal('error', 'Ошибка валидации', 'Выберите валюту и сеть');
            return
          }
          if (!cryptoNetwork) {
            openModal('error', 'Ошибка валидации', 'Выберите валюту и сеть');
            return
          }
          const requestBody = {
            amount: amount,
            currency: cryptoCurrency, 
            network: cryptoNetwork,
            deviceData: "",
            ...(showEmail && { email: email })
          };
         
          try {
            const response = await fetch(`https://ipalinks.ru/create-payments-crypto/${orderId}/${token}/${timestamp}/`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(requestBody)
      });

      if (response.ok) {
        const result = await response.json();
        setIsLoading(false);
        
        // Показываем страницу с QR-кодом
        setCryptoPaymentData({
          qr: result.qr,
          amount: result.amount,
          address: result.address,
          creation_time: result.creation_time,
          currency: cryptoCurrency,
          network: cryptoNetwork,
          orderId: orderId
        });
        
        // Вычисляем оставшееся время (2 часа с момента создания)
        const creationTime = new Date(result.creation_time);
        const currentTime = new Date();
        const elapsedSeconds = Math.floor((currentTime - creationTime) / 1000);
        const remainingTime = Math.max(0, 7200 - elapsedSeconds);
        
        setTimeLeft(remainingTime);
        setShowCryptoPayment(true);
        
      } else {
        setIsLoading(false);
        const errorData = await response.json().catch(() => ({}));
        openModal('error', 'Ошибка создания платежа', 
          errorData.message || `Ошибка сервера (${response.status})`);
      }
    } catch (error) {
      setIsLoading(false);
      openModal('error', 'Ошибка создания платежа', `Ошибка оплаты: ${error.message}`);
    }
      setIsLoading(false);
    } else {


      const checkout = getWataCheckout();
      const cardNumber = cardData.number.replace(/\s/g, '');
      
      if (!cardNumber || cardNumber.length < 16) {
        openModal('error', 'Ошибка валидации', 'Введите корректный номер банковской карты (16 цифр)');
        return;
      }
      
      if (!cardData.expiry || cardData.expiry.length < 5) {
        openModal('error', 'Ошибка валидации', 'Введите срок действия карты в формате ММ/ГГ');
        return;
      }
      
      if (!cardData.cvv || cardData.cvv.length < 3) {
        openModal('error', 'Ошибка валидации', 'Введите CVV код (3 цифры на обратной стороне карты)');
        return;
      }

      const cardDataForValidation = {
        number: cardNumber,
        expirationMonth: Number(cardData.expiry.split("/")[0]),
        expirationYear: Number(cardData.expiry.split("/")[1]),
        cvv: cardData.cvv,
      };

      const errors = checkout.validate(cardDataForValidation);
      if (errors) {
        openModal('error', 'Ошибка валидации', 'Ошибка платежных данных');
        return;
      }

      setIsLoading(true);

      try {
        const encryptedData = await checkout.encrypt(cardDataForValidation);
        console.log(encryptedData.encryptedString)
        const requestBody = {
          amount: amount,
          deviceData: "",
          cardCrypto: encryptedData.encryptedString,
          ...(showEmail && { email: email })
        };

        const response = await fetch(`https://www.ipalinks.ru/create-payments-card/${orderId}/${token}/${timestamp}/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestBody)
        });

        if (response.ok) {
          const result = await response.json();
          setIsLoading(false);

          if (result.method === "GET") {
            window.location.href = result.url;
          } else if (result.threeDsData) {
            handle3DSecure(result.threeDsData);
          }

          openModal('success', 'Платеж создан!', 
            showEmail ? `После оплаты чек будет отправлен на: ${email}` : 'Счет на оплату сформирован');
        } else {
          setIsLoading(false);
          const errorData = await response.json().catch(() => ({}));
          console.error('Ошибка создания платежа:', response.status, errorData);
          openModal('error', 'Ошибка создания платежа', 
            errorData.message || `Ошибка сервера (${response.status})`);
        }
      } catch (error) {
        setIsLoading(false);
        console.error('Ошибка платежа:', error);
        
        if (error.name === 'TypeError' && error.message.includes('fetch')) {
          openModal('error', 'Ошибка сети', 'Проверьте подключение к интернету и попробуйте снова');
        } else {
          openModal('error', 'Ошибка создания платежа', `Ошибка оплаты: ${error.message}`);
        }
      }
    }
  };
   useEffect(() => {
  // Запускаем проверку статуса когда получены данные конфигурации
  if (orderId && orderId !== "0" && token && token !== "_" && timestamp && timestamp !== "0") {

    
    // Запускаем с небольшой задержкой чтобы убедиться что все инициализировано
    setTimeout(() => {
      startStatusPolling();
    }, 1000);
  }
}, [orderId, token, timestamp]);
  const getCardPreview = () => {
    const number = cardData.number.replace(/\s/g, '');
    if (number.length > 0) {
      return number.padEnd(16, '*').replace(/(.{4})/g, '$1 ').trim();
    }
    return '**** **** **** ****';
  };

  const getExpiryPreview = () => {
    return cardData.expiry || 'MM/YY';
  };


  return (
    
    <div className={styles.paymentWrapper}>
      {preloader && (<div className='preloader'>
        <div className="spinner"></div>
      </div>)}
      
       <div className={styles.paymentContainer}>
        
        {/* Header */}
        {!showCryptoPayment ? (
        <div>
        <div className={styles.paymentHeader}>
          <h1>Оплата заказа</h1>
          <p>Выберите удобный способ оплаты</p>
        </div>

        {/* Amount Display */}
        <div className={styles.amountDisplay}>
          <div className={styles.amount}>{formatAmount(amount)} ₽</div>
          <div className={styles.currency}>Российский рубль</div>
        </div>

        {/* Email Input */}
        {(showEmail || selectedMethod == 'sbp-reserve') && (
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>
              Email для чека
            </label>
            <input
              type="email"
              value={email}
              onChange={handleEmailChange}
              className={`${styles.formInput} ${emailValid === false ? styles.error : emailValid === true ? styles.success : ''}`}
              placeholder="ivan@example.com"
              required
            />
            {emailValid === false && (
              <div className={styles.errorMessage}>Введите корректный email адрес</div>
            )}
            {emailValid === true && (
              <div className={styles.successMessage}>Email корректный</div>
            )}
          </div>
        )}

        {/* Payment Methods */}
        <div className={styles.paymentMethods}>
          <div className={styles.methodOptions}>
            {(enableSbp && amount >= 100) && (
              <div className={styles.methodOption}>
                <input
                  type="radio"
                  id="sbp"
                  name="payment-method"
                  value="sbp"
                  checked={selectedMethod === 'sbp'}
                  onChange={(e) => setSelectedMethod(e.target.value)}
                />
                <label htmlFor="sbp">
                  <div className={styles.methodIcon}>
                    <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="m3 5.79 2.66 4.76v2.9L3 18.22V5.79Z" fill="#5B57A2"></path>
                      <path d="m13.23 8.82 2.5-1.53h5.1l-7.6 4.65V8.82Z" fill="#D90751"></path>
                      <path d="M13.22 5.76v6.3l-2.66-1.64V1l2.66 4.76Z" fill="#FAB718"></path>
                      <path d="M20.84 7.28h-5.11l-2.51-1.52L10.56 1l10.28 6.28Z" fill="#ED6F26"></path>
                      <path d="M13.23 18.23v-3.05l-2.67-1.61V23l2.67-4.77Z" fill="#63B22F"></path>
                      <path d="M15.72 16.72 5.66 10.55 3 5.8l17.82 10.9h-5.1Z" fill="#1487C9"></path>
                      <path d="m10.56 23 2.67-4.77 2.49-1.51h5.1L10.56 23Z" fill="#017F36"></path>
                      <path d="m3 18.2 7.58-4.63L8.03 12l-2.37 1.46L3 18.2Z" fill="#984995"></path>
                    </svg>
                  </div>
                  <div className={styles.methodName}>СБП</div>
                </label>
              </div>
            )}
            {(amount >= 10) && (
              <div className={styles.methodOption}>
                <input
                  type="radio"
                  id="sbp-reserve"
                  name="payment-method"
                  value="sbp-reserve"
                  checked={selectedMethod === 'sbp-reserve'}
                  onChange={(e) => setSelectedMethod(e.target.value)}
                />
                <label htmlFor="sbp-reserve">
                  <div className={styles.methodIcon}>
                    <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="m3 5.79 2.66 4.76v2.9L3 18.22V5.79Z" fill="#5B57A2"></path>
                      <path d="m13.23 8.82 2.5-1.53h5.1l-7.6 4.65V8.82Z" fill="#D90751"></path>
                      <path d="M13.22 5.76v6.3l-2.66-1.64V1l2.66 4.76Z" fill="#FAB718"></path>
                      <path d="M20.84 7.28h-5.11l-2.51-1.52L10.56 1l10.28 6.28Z" fill="#ED6F26"></path>
                      <path d="M13.23 18.23v-3.05l-2.67-1.61V23l2.67-4.77Z" fill="#63B22F"></path>
                      <path d="M15.72 16.72 5.66 10.55 3 5.8l17.82 10.9h-5.1Z" fill="#1487C9"></path>
                      <path d="m10.56 23 2.67-4.77 2.49-1.51h5.1L10.56 23Z" fill="#017F36"></path>
                      <path d="m3 18.2 7.58-4.63L8.03 12l-2.37 1.46L3 18.2Z" fill="#984995"></path>
                    </svg>
                  </div>
                  <div className={styles.methodName}>СБП (5%)</div>
                </label>
              </div>
            )}
            {enableCard && (
              <div className={styles.methodOption}>
                <input
                  type="radio"
                  id="card"
                  name="payment-method"
                  value="card"
                  checked={selectedMethod === 'card'}
                  onChange={(e) => setSelectedMethod(e.target.value)}
                />
                <label htmlFor="card">
                  <div className={styles.methodIcon}>
                    <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2 16c0 1.7 1.3 3 3 3h14c1.7 0 3-1.3 3-3v-6H2v6Zm3-4h3c.6 0 1 .4 1 1s-.4 1-1 1H5c-.6 0-1-.4-1-1s.4-1 1-1Zm14-8H5C3.3 4 2 5.3 2 7v1h20V7c0-1.7-1.3-3-3-3Z" fill="currentColor"/>
                    </svg>
                  </div>
                  <div className={styles.methodName}>Карта (RU)</div>
                </label>
              </div>
            )}
            {(amount >= 100) && (<div className={styles.methodOption}>
              <input type="radio" id="crypto" name="payment-method" value="crypto" checked={selectedMethod === 'crypto'} onChange={(e) => setSelectedMethod(e.target.value)}/>
              <label htmlFor="crypto">
                  <div className={styles.methodIcon}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><g fill="none" fillRule="evenodd"><circle cx="16" cy="16" r="16" fill="#26A17B"></circle><path fill="#FFF" d="M17.922 17.383v-.002c-.11.008-.677.042-1.942.042c-1.01 0-1.721-.03-1.971-.042v.003c-3.888-.171-6.79-.848-6.79-1.658c0-.809 2.902-1.486 6.79-1.66v2.644c.254.018.982.061 1.988.061c1.207 0 1.812-.05 1.925-.06v-2.643c3.88.173 6.775.85 6.775 1.658c0 .81-2.895 1.485-6.775 1.657m0-3.59v-2.366h5.414V7.819H8.595v3.608h5.414v2.365c-4.4.202-7.709 1.074-7.709 2.118c0 1.044 3.309 1.915 7.709 2.118v7.582h3.913v-7.584c4.393-.202 7.694-1.073 7.694-2.116c0-1.043-3.301-1.914-7.694-2.117"></path></g></svg>
                  </div>
                  <div className={styles.methodName}>Криптовалюта</div>
              </label>
            </div>)}
          </div>
          
          {/* Card Form */}
          {selectedMethod === 'card' && (
            <div className={`${styles.cardForm} ${selectedMethod === 'card' ? styles.active : ''}`}>
              {/* Card Preview */}
              <div className={styles.cardPreview}>
                <div className={styles.cardNumberPreview}>
                  {getCardPreview()}
                </div>
                <div className={styles.cardDetails}>
                  <span>{getExpiryPreview()}</span>
                </div>
              </div>

              {/* Card Number */}
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>
                  Номер карты
                </label>
                <input
                  type="text"
                  value={cardData.number}
                  onChange={handleCardNumberChange}
                  className={styles.formInput}
                  placeholder="1234 5678 9012 3456"
                  maxLength="19"
                />
              </div>

              {/* Expiry and CVV */}
              <div className={styles.formRow}>
                <div className={styles.formGroup}>
                  <label className={styles.formLabel}>
                    Срок действия
                  </label>
                  <input
                    type="text"
                    value={cardData.expiry}
                    onChange={handleExpiryChange}
                    className={styles.formInput}
                    placeholder="ММ/ГГ"
                    maxLength="5"
                  />
                </div>
                <div className={styles.formGroup}>
                  <label className={styles.formLabel}>
                    CVV
                  </label>
                  <div className={styles.cvvInputContainer}>
                    <input
                      type={showCvv ? "text" : "password"}
                      value={cardData.cvv}
                      onChange={handleCvvChange}
                      className={styles.formInput}
                      placeholder="123"
                      maxLength="3"
                    />
                    <button
                      type="button"
                      onClick={() => setShowCvv(!showCvv)}
                      className={styles.cvvToggle}
                    >
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9ZM12 17C10.6739 17 9.40215 16.4732 8.46447 15.5355C7.52678 14.5979 7 13.3261 7 12C7 10.6739 7.52678 9.40215 8.46447 8.46447C9.40215 7.52678 10.6739 7 12 7C13.3261 7 14.5979 7.52678 15.5355 8.46447C16.4732 9.40215 17 10.6739 17 12C17 13.3261 16.4732 14.5979 15.5355 15.5355C14.5979 16.4732 13.3261 17 12 17ZM12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5Z"/>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          {
          selectedMethod === 'crypto' && (
            <div className={styles.cryptoForm} id="cryptoForm">
                    <div className={styles.cryptoSelector}>
                        <div className={styles.formLabel}>Выберите криптовалюту</div>
                        <div className={styles.cryptoGrid}>
                            
                            <CryptoOption icon={<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><g fill="none" fillRule="evenodd"><circle cx="16" cy="16" r="16" fill="#26A17B"/><path fill="#FFF" d="M17.922 17.383v-.002c-.11.008-.677.042-1.942.042c-1.01 0-1.721-.03-1.971-.042v.003c-3.888-.171-6.79-.848-6.79-1.658c0-.809 2.902-1.486 6.79-1.66v2.644c.254.018.982.061 1.988.061c1.207 0 1.812-.05 1.925-.06v-2.643c3.88.173 6.775.85 6.775 1.658c0 .81-2.895 1.485-6.775 1.657m0-3.59v-2.366h5.414V7.819H8.595v3.608h5.414v2.365c-4.4.202-7.709 1.074-7.709 2.118c0 1.044 3.309 1.915 7.709 2.118v7.582h3.913v-7.584c4.393-.202 7.694-1.073 7.694-2.116c0-1.043-3.301-1.914-7.694-2.117"/></g></svg>} name='USDT' fullname='USDT' setCryptoCurrency={setCryptoCurrency} cryptoCurrency={cryptoCurrency}/>
                            <CryptoOption icon={<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><g fill="none"><circle cx="16" cy="16" r="16" fill="#3E73C4"/><g fill="#FFF"><path d="M20.022 18.124c0-2.124-1.28-2.852-3.84-3.156c-1.828-.243-2.193-.728-2.193-1.578c0-.85.61-1.396 1.828-1.396c1.097 0 1.707.364 2.011 1.275a.458.458 0 0 0 .427.303h.975a.416.416 0 0 0 .427-.425v-.06a3.04 3.04 0 0 0-2.743-2.489V9.142c0-.243-.183-.425-.487-.486h-.915c-.243 0-.426.182-.487.486v1.396c-1.829.242-2.986 1.456-2.986 2.974c0 2.002 1.218 2.791 3.778 3.095c1.707.303 2.255.668 2.255 1.639c0 .97-.853 1.638-2.011 1.638c-1.585 0-2.133-.667-2.316-1.578c-.06-.242-.244-.364-.427-.364h-1.036a.416.416 0 0 0-.426.425v.06c.243 1.518 1.219 2.61 3.23 2.914v1.457c0 .242.183.425.487.485h.915c.243 0 .426-.182.487-.485V21.34c1.829-.303 3.047-1.578 3.047-3.217z"/><path d="M12.892 24.497c-4.754-1.7-7.192-6.98-5.424-11.653c.914-2.55 2.925-4.491 5.424-5.402c.244-.121.365-.303.365-.607v-.85c0-.242-.121-.424-.365-.485c-.061 0-.183 0-.244.06a10.895 10.895 0 0 0-7.13 13.717c1.096 3.4 3.717 6.01 7.13 7.102c.244.121.488 0 .548-.243c.061-.06.061-.122.061-.243v-.85c0-.182-.182-.424-.365-.546m6.46-18.936c-.244-.122-.488 0-.548.242c-.061.061-.061.122-.061.243v.85c0 .243.182.485.365.607c4.754 1.7 7.192 6.98 5.424 11.653c-.914 2.55-2.925 4.491-5.424 5.402c-.244.121-.365.303-.365.607v.85c0 .242.121.424.365.485c.061 0 .183 0 .244-.06a10.895 10.895 0 0 0 7.13-13.717c-1.096-3.46-3.778-6.07-7.13-7.162"/></g></g></svg>} name='USDC' fullname='USDC' setCryptoCurrency={setCryptoCurrency} cryptoCurrency={cryptoCurrency}/>
                            <CryptoOption icon={<svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
<path d="M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z" fill="#0098EA"/>
<path d="M37.5603 15.6277H18.4386C14.9228 15.6277 12.6944 19.4202 14.4632 22.4861L26.2644 42.9409C27.0345 44.2765 28.9644 44.2765 29.7345 42.9409L41.5381 22.4861C43.3045 19.4251 41.0761 15.6277 37.5627 15.6277H37.5603ZM26.2548 36.8068L23.6847 31.8327L17.4833 20.7414C17.0742 20.0315 17.5795 19.1218 18.4362 19.1218H26.2524V36.8092L26.2548 36.8068ZM38.5108 20.739L32.3118 31.8351L29.7417 36.8068V19.1194H37.5579C38.4146 19.1194 38.9199 20.0291 38.5108 20.739Z" fill="white"/>
</svg>} name='TON' fullname='TonCoin' setCryptoCurrency={setCryptoCurrency} cryptoCurrency={cryptoCurrency}/>

 
                            
                        </div>
                    </div>

                    {cryptoCurrency && (<div className={styles.networkSelector} id="networkSelector">
                        <div className={styles.formLabel}>Выберите сеть</div>
                        <div className={styles.networkList} id="networkList">
                          {availableNetworks.map((network) => (
                            <NetworkOption id={network.id} name={network.name} desc={network.desc} color={network.color} icon={network.icon} setCryptoNetwork={setCryptoNetwork}/>
                          ))}
                        </div>
                    </div>)}
                </div>
          )
        }
        </div>
        

        {/* Pay Button */}
        <button
          onClick={processPayment}
          disabled={isLoading}
          className={styles.payButton}
        >
          {isLoading ? (
            <>
              <div className={styles.loader}></div>
              Обработка платежа...
            </>
          ) : (
            `Оплатить ${formatAmount(amount)} ₽`
          )}
        </button>

        {/* Security Info */}
        <div className={styles.securityInfo}>
          <span className={styles.securityIcon}>🔒</span>
          Защищенное соединение SSL
        </div>
      </div>) : (
        /* Crypto Payment Page */
        <div className={styles.cryptoPaymentPage}>
          {/* Header */}
          <div className={styles.cryptoHeader}>
            <button onClick={goBackToPayment} className={styles.backButton}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12H5M12 19L5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            <h1>Оплата криптовалютой</h1>
          </div>

          {/* Timer */}
          <div className={styles.timerBlock}>
            <div className={styles.timerIcon}><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff"><path d="M360-840v-80h240v80H360Zm80 440h80v-240h-80v240Zm40 320q-74 0-139.5-28.5T226-186q-49-49-77.5-114.5T120-440q0-74 28.5-139.5T226-694q49-49 114.5-77.5T480-800q62 0 119 20t107 58l56-56 56 56-56 56q38 50 58 107t20 119q0 74-28.5 139.5T734-186q-49 49-114.5 77.5T480-80Zm0-80q116 0 198-82t82-198q0-116-82-198t-198-82q-116 0-198 82t-82 198q0 116 82 198t198 82Zm0-280Z"/></svg></div>
            <div className={styles.timerText}>
              <div className={styles.timerLabel}>Время для оплаты:</div>
              <div className={`${styles.timerTime} ${timeLeft < 300 ? styles.timerCritical : ''}`}>
                {formatTime(timeLeft)}
              </div>
            </div>
          </div>

          {/* QR Code */}
          <div className={styles.qrContainer}>
            <div className={styles.qrCode}>
              <img 
                src={cryptoPaymentData?.qr} 
                alt="QR Code" 
                className={styles.qrImage}
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              <div className={styles.qrPlaceholder} style={{display: 'none'}}>
                <div className={styles.qrPlaceholderIcon}><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M120-520v-320h320v320H120Zm80-80h160v-160H200v160Zm-80 480v-320h320v320H120Zm80-80h160v-160H200v160Zm320-320v-320h320v320H520Zm80-80h160v-160H600v160Zm160 480v-80h80v80h-80ZM520-360v-80h80v80h-80Zm80 80v-80h80v80h-80Zm-80 80v-80h80v80h-80Zm80 80v-80h80v80h-80Zm80-80v-80h80v80h-80Zm0-160v-80h80v80h-80Zm80 80v-80h80v80h-80Z"/></svg></div>
                <div>QR код недоступен</div>
              </div>
            </div>
            <div className={styles.scanText}>Отсканируйте QR-код в вашем криптокошельке</div>
          </div>

          {/* Payment Info */}
          <div className={styles.paymentInfo}>
            <div className={styles.cryptoCurrency}>
            
              <div className={styles.currencyInfo}>
                <div className={styles.currencyName}>{cryptoPaymentData?.currency}</div>
                <div className={styles.networkName}>{cryptoPaymentData?.network} Network</div>
              </div>
            </div>

            <div className={styles.amountInfo}>
              <div className={styles.amountLabel}>Сумма к оплате:</div>
              <div className={styles.cryptoAmount}>{cryptoPaymentData?.amount} {cryptoPaymentData?.currency}</div>
            </div>

            <div className={styles.addressInfo}>
              <div className={styles.addressLabel}>Адрес кошелька:</div>
              <div className={styles.addressContainer}>
                <div className={styles.address}>{cryptoPaymentData?.address}</div>
                <button 
                  onClick={() => copyToClipboard(cryptoPaymentData?.address)}
                  className={styles.copyButton}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M360-240q-33 0-56.5-23.5T280-320v-480q0-33 23.5-56.5T360-880h360q33 0 56.5 23.5T800-800v480q0 33-23.5 56.5T720-240H360Zm0-80h360v-480H360v480ZM200-80q-33 0-56.5-23.5T120-160v-560h80v560h440v80H200Zm160-240v-480 480Z"/></svg>
                </button>
              </div>
            </div>
          </div>

          {/* Warning */}
          <div className={styles.warningBlock}>
            <div className={styles.warningIcon}><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="M480-79q-16 0-30.5-6T423-102L102-423q-11-12-17-26.5T79-480q0-16 6-31t17-26l321-321q12-12 26.5-17.5T480-881q16 0 31 5.5t26 17.5l321 321q12 11 17.5 26t5.5 31q0 16-5.5 30.5T858-423L537-102q-11 11-26 17t-31 6Zm0-80 321-321-321-321-321 321 321 321Zm-40-281h80v-240h-80v240Zm40 120q17 0 28.5-11.5T520-360q0-17-11.5-28.5T480-400q-17 0-28.5 11.5T440-360q0 17 11.5 28.5T480-320Zm0-160Z"/></svg></div>
            <div className={styles.warningText}>
              <strong>Важно!</strong> Переведите точную сумму <strong>{cryptoPaymentData?.amount} {cryptoPaymentData?.currency}</strong>. 
              При переводе неточной суммы платеж не будет зачислен автоматически.<br></br>
              <strong>После оплаты оставайтесь на сайте оплаты до переадресации на конечную страницу</strong>
            </div>
          </div>

          {/* Status Info */}
          <div className={styles.statusInfo}>
            <div className={styles.statusItem}>
              <div className={styles.statusIcon}><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#4a5568"><path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z"/></svg></div>
              <div className={styles.statusText}>Ожидаем поступления средств...</div>
            </div>
            <div className={styles.statusItem}>
              <div className={styles.statusIcon}><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#4a5568"><path d="M160-160v-516L82-846l72-34 94 202h464l94-202 72 34-78 170v516H160Zm240-280h160q17 0 28.5-11.5T600-480q0-17-11.5-28.5T560-520H400q-17 0-28.5 11.5T360-480q0 17 11.5 28.5T400-440ZM240-240h480v-358H240v358Zm0 0v-358 358Z"/></svg></div>
              <div className={styles.statusText}>Заказ №{cryptoPaymentData?.orderId}</div>
            </div>
          </div>
        </div>
      )}
    </div>

      {/* Modal */}
      {showModal && (
        <div className={classNames(styles.modalOverlay,styles.show)} onClick={closeModal}>
          <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
            <div className={`${styles.modalIcon} ${modalData.type}`}>
              {modalData.type === 'error' ? '❌' : '✅'}
            </div>
            <h3 className={styles.modalTitle}>{modalData.title}</h3>
            <p className={styles.modalMessage}>{modalData.message}</p>
            <button
              onClick={closeModal}
              className={`${styles.modalButton} ${modalData.type}`}
            >
              Понятно
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentForm;